import Dashlet from "../../controls/Dashlet";
import Icon from "../../controls/Icon";
import { IconButton } from "../../controls/TooltipControls";
import { ComponentEx, connect, translate } from "../../controls/ComponentEx";
import { dismissStep } from "./actions";
import * as _ from "lodash";
import * as React from "react";
class Todo extends React.PureComponent {
    render() {
        const { t, extensionProps, todo } = this.props;
        const text = this.resolveElement(todo.text, "todo-text");
        const value = this.resolveElement(todo.value, "todo-value");
        const icon = typeof todo.icon === "string" ? (React.createElement(Icon, { name: todo.icon })) : (todo.icon(extensionProps));
        return (React.createElement("div", { key: todo.id, className: `todo todo-${todo.type}`, onClick: this.action },
            icon,
            text,
            value,
            React.createElement(IconButton, { id: `btn-dismiss-${todo.id}`, icon: "close-slim", tooltip: t("Dismiss"), className: "btn-embed btn-dismiss", value: todo.id, onClick: this.dismiss })));
    }
    action = () => {
        this.props.todo.action(this.props.extensionProps);
    };
    dismiss = (evt) => {
        evt.stopPropagation();
        this.props.dismiss(this.props.todo.id);
    };
    resolveElement(input, className) {
        const { t, extensionProps } = this.props;
        return input === undefined ? null : typeof input === "string" ? (React.createElement("span", { className: className }, t(input))) : (React.createElement("div", { className: className }, input(t, extensionProps)));
    }
}
class TodoDashlet extends ComponentEx {
    constructor(inProps) {
        super(inProps);
    }
    shouldComponentUpdate(newProps) {
        return (newProps.dismissAll !== this.props.dismissAll ||
            newProps.steps !== this.props.steps ||
            !_.isEqual(newProps.extensionProps, this.props.extensionProps));
    }
    render() {
        const { t, dismissAll, extensionProps, steps, todos } = this.props;
        if (dismissAll) {
            return null;
        }
        const visibleSteps = todos.filter((step) => {
            if (steps[step.id]) {
                return false;
            }
            if (step.condition !== undefined) {
                const props = extensionProps[step.id];
                return step.condition(props);
            }
            else {
                return true;
            }
        });
        visibleSteps.sort((lhs, rhs) => (lhs.priority || 100) - (rhs.priority || 100));
        return (React.createElement(Dashlet, { title: t("Let's get you set up"), className: "dashlet-todo" },
            React.createElement("div", null, visibleSteps.map((todo) => (React.createElement(Todo, { t: t, key: todo.id, todo: todo, extensionProps: extensionProps[todo.id], dismiss: this.dismiss }))))));
    }
    dismiss = (id) => {
        this.props.onDismissStep(id);
    };
}
function mapStateToProps(state, ownProps) {
    const extensionProps = {};
    ownProps.todos.forEach((todo) => {
        extensionProps[todo.id] = todo.props !== undefined ? todo.props(state) : {};
    });
    return {
        // Defensive checks: firststeps might not be initialized during hydration
        dismissAll: state.settings?.firststeps?.dismissAll ?? false,
        steps: state.settings?.firststeps?.steps ?? {},
        extensionProps,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onDismissStep: (step) => dispatch(dismissStep(step)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(TodoDashlet));
